import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=1bc3a608&scoped=true"
import script from "./inquiry.vue?vue&type=script&lang=js"
export * from "./inquiry.vue?vue&type=script&lang=js"
import style0 from "./inquiry.vue?vue&type=style&index=0&id=1bc3a608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3a608",
  null
  
)

export default component.exports